var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerAnswerBottomFeedbackText } from './AbfragerAnswerBottomFeedbackText';
import { AbfragerAnswerBottomFeedbackTime } from './AbfragerAnswerBottomFeedbackTime';
import { AbfragerBottomButton } from '../../layout/answerbottom/AbfragerBottomButton';
import { AbfragerBottomLine } from '../../layout/answerbottom/AbfragerBottomLine';
let ShowQuestionAnswerBottomFeedback = class ShowQuestionAnswerBottomFeedback extends React.PureComponent {
    get appClock() {
        return this.props.question.context.app.appClock;
    }
    render() {
        const { question } = this.props;
        const left = React.createElement(AbfragerAnswerBottomFeedbackText, { question: question });
        const right = (React.createElement("div", { style: { flex: '0 1 auto', display: 'flex' } },
            React.createElement(AbfragerAnswerBottomFeedbackTime, { question: question }),
            !this.appClock.isAppClockPaused && (React.createElement(AbfragerBottomButton, { typ: 1, onClick: () => (this.appClock.isAppClockPaused = true), style: { minWidth: 67 } }, "Pause")),
            this.appClock.isAppClockPaused && (React.createElement(AbfragerBottomButton, { typ: 1, onClick: () => (this.appClock.isAppClockPaused = false), style: { minWidth: 67 } }, "Weiter")),
            React.createElement(AbfragerBottomButton, { typ: 0, onClick: question.context.app.cycle.cycleNavigate.handleNextClick }, "Sofort weiter")));
        return React.createElement(AbfragerBottomLine, { left: left, right: right });
    }
};
ShowQuestionAnswerBottomFeedback = __decorate([
    observer
], ShowQuestionAnswerBottomFeedback);
export { ShowQuestionAnswerBottomFeedback };
